import { render, staticRenderFns } from "./CreateManage.vue?vue&type=template&id=5aa484fa&"
import script from "./CreateManage.vue?vue&type=script&lang=js&"
export * from "./CreateManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports